"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const auth_service_1 = require("../services/auth.service");
const environment_enum_1 = require("../enum/environment.enum");
let refresh = false;
axios_1.default.defaults.baseURL = '';
let configNull = null;
axios_1.default.interceptors.response.use(resp => resp, async (error) => {
    if (error.response.status === 401 && !refresh) {
        refresh = true;
        const KEY = 'K7YoU4xhGVangqLDKOzOw2JtpeMyYq1M5Tke8PLA';
        const authService = new auth_service_1.AuthService(environment_enum_1.ENVIRONMENT.QA, KEY);
        let token = localStorage.getItem('tokenPoint');
        let email_session = JSON.parse(localStorage.admin_session).user.email;
        console.log('EMAIL--SESSION', email_session);
        let body = { email: email_session, client: 'web', token };
        const responseRefresh = await authService.refreshToken(body);
        console.log('responseRefresh', responseRefresh);
        if (responseRefresh.token) {
            console.log('responseRefresh.token', responseRefresh);
            localStorage.setItem('tokenPoint', responseRefresh.token);
            axios_1.default.defaults.headers.common['Authorization'] = `Bearer ${responseRefresh.token}`;
            return (0, axios_1.default)(error.config);
        }
    }
    refresh = false;
    return error;
});
